const EssentialGuide = () => {
  return (
    <div>
      <button>필수가이드</button>
    </div>
  )
}

export default EssentialGuide;